/* ============================================================
   SILKEE SOFT — theme.js
   Vanilla JS. Works on Shopify (AJAX cart) and in static
   preview mode (window.SILKEE_PREVIEW = true → localStorage).
   ============================================================ */
(function () {
  "use strict";
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));
  const PREVIEW = !!window.SILKEE_PREVIEW;
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- Money (PKR) ---------- */
  function money(cents) {
    return "Rs. " + Math.round(cents / 100).toLocaleString("en-PK");
  }

  /* ---------- Preloader (first visit per session) ---------- */
  const pre = $(".preloader");
  if (pre) {
    if (sessionStorage.getItem("ss-seen") || reduceMotion) {
      pre.remove();
    } else {
      sessionStorage.setItem("ss-seen", "1");
      window.addEventListener("load", () => {
        setTimeout(() => pre.classList.add("done"), 350);
        setTimeout(() => pre.remove(), 1100);
      });
      /* Failsafe */
      setTimeout(() => { pre.classList.add("done"); setTimeout(() => pre.remove(), 700); }, 2600);
    }
  }

  /* ---------- Header: shadow + hide on scroll down ---------- */
  const header = $(".site-header");
  if (header) {
    let lastY = 0;
    window.addEventListener("scroll", () => {
      const y = window.scrollY;
      header.classList.toggle("is-scrolled", y > 10);
      if (y > 320 && y > lastY + 6) header.classList.add("is-hidden");
      else if (y < lastY - 6 || y < 320) header.classList.remove("is-hidden");
      lastY = y;
    }, { passive: true });
  }

  /* ---------- Mobile nav ---------- */
  const mnav = $(".mobile-nav");
  if (mnav) {
    const open = () => { mnav.classList.add("open"); document.body.style.overflow = "hidden"; };
    const close = () => { mnav.classList.remove("open"); document.body.style.overflow = ""; };
    $$("[data-nav-open]").forEach((b) => b.addEventListener("click", open));
    $$("[data-nav-close], .mobile-nav__scrim", mnav.parentElement).forEach((b) => b.addEventListener("click", close));
  }

  /* ---------- Marquee: duplicate track for seamless loop ---------- */
  $$(".marquee__track, .announcement__track").forEach((track) => {
    track.innerHTML += track.innerHTML;
  });

  /* ---------- Reveal on scroll ---------- */
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) { e.target.classList.add("in-view"); io.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: "0px 0px -6% 0px" });
  $$("[data-reveal], [data-reveal-stagger]").forEach((el) => io.observe(el));

  /* ---------- Animated counters ---------- */
  const cio = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (!e.isIntersecting) return;
      cio.unobserve(e.target);
      const el = e.target, target = parseFloat(el.dataset.count || "0");
      const suffix = el.dataset.suffix || "", dur = 1400, t0 = performance.now();
      (function tick(t) {
        const p = Math.min(1, (t - t0) / dur), ease = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * ease).toLocaleString("en-PK") + suffix;
        if (p < 1) requestAnimationFrame(tick);
      })(t0);
    });
  }, { threshold: 0.6 });
  $$("[data-count]").forEach((el) => cio.observe(el));

  /* ---------- Countdown (launch offer) ---------- */
  $$("[data-countdown]").forEach((box) => {
    let end = new Date(box.dataset.countdown).getTime();
    if (isNaN(end) || end < Date.now()) {
      /* Evergreen fallback: rolls to next midnight so the offer never shows 00:00:00 */
      const d = new Date(); d.setHours(24, 0, 0, 0); end = d.getTime();
    }
    const els = {
      d: $("[data-cd-d]", box), h: $("[data-cd-h]", box),
      m: $("[data-cd-m]", box), s: $("[data-cd-s]", box)
    };
    const pad = (n) => String(n).padStart(2, "0");
    (function tick() {
      let diff = Math.max(0, end - Date.now());
      const day = Math.floor(diff / 864e5), hr = Math.floor(diff / 36e5) % 24,
            mi = Math.floor(diff / 6e4) % 60, se = Math.floor(diff / 1e3) % 60;
      if (els.d) els.d.textContent = pad(day);
      if (els.h) els.h.textContent = pad(hr);
      if (els.m) els.m.textContent = pad(mi);
      if (els.s) els.s.textContent = pad(se);
      setTimeout(tick, 1000);
    })();
  });

  /* ---------- Ritual scrollytelling ---------- */
  const ritual = $("[data-ritual]");
  if (ritual) {
    const steps = $$(".ritual-step", ritual);
    const imgs = $$(".ritual-stage__frame img", ritual);
    const num = $(".ritual-stage__num", ritual);
    const activate = (i) => {
      steps.forEach((s, j) => s.classList.toggle("active", i === j));
      imgs.forEach((im, j) => im.classList.toggle("active", i === j));
      if (num) num.textContent = "0" + (i + 1);
    };
    activate(0);
    const rio = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) activate(steps.indexOf(e.target));
      });
    }, { rootMargin: "-42% 0px -42% 0px" });
    steps.forEach((s) => rio.observe(s));
    steps.forEach((s, i) => s.addEventListener("click", () => activate(i)));
  }

  /* ---------- Rails (testimonials etc.) ---------- */
  $$("[data-rail]").forEach((wrap) => {
    const rail = $(".testi-rail", wrap) || $("[data-rail-track]", wrap);
    if (!rail) return;
    const step = () => (rail.firstElementChild ? rail.firstElementChild.getBoundingClientRect().width + 22 : 320);
    $$("[data-rail-prev]", wrap).forEach((b) => b.addEventListener("click", () => rail.scrollBy({ left: -step(), behavior: "smooth" })));
    $$("[data-rail-next]", wrap).forEach((b) => b.addEventListener("click", () => rail.scrollBy({ left: step(), behavior: "smooth" })));
  });

  /* ---------- Product gallery ---------- */
  const gallery = $("[data-gallery]");
  if (gallery) {
    const main = $(".gallery__main img", gallery);
    $$(".gallery__thumb", gallery).forEach((th) => {
      th.addEventListener("click", () => {
        $$(".gallery__thumb", gallery).forEach((t) => t.classList.remove("active"));
        th.classList.add("active");
        main.classList.add("switching");
        setTimeout(() => {
          main.src = th.dataset.full || $("img", th).src;
          if (th.dataset.alt) main.alt = th.dataset.alt;
          main.onload = () => main.classList.remove("switching");
        }, 180);
      });
    });
  }

  /* ---------- Quantity steppers (product page only — cart lines are handled by the drawer) ---------- */
  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-qty-plus], [data-qty-minus]");
    if (!btn || btn.hasAttribute("data-line")) return;
    const input = $("input", btn.closest(".qty"));
    let v = parseInt(input.value || "1", 10);
    if (isNaN(v)) v = 1;
    v += btn.hasAttribute("data-qty-plus") ? 1 : -1;
    input.value = Math.max(1, v);
  });

  /* ---------- Toast ---------- */
  let toastEl, toastTimer;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement("div"); toastEl.className = "toast"; document.body.appendChild(toastEl); }
    toastEl.textContent = msg;
    requestAnimationFrame(() => toastEl.classList.add("show"));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove("show"), 2600);
  }

  /* ============================================================
     CART — Shopify AJAX or preview localStorage mock
     ============================================================ */
  const Cart = {
    async get() {
      if (PREVIEW) return this._mock();
      const r = await fetch("/cart.js"); return r.json();
    },
    async add(id, qty, item) {
      if (PREVIEW) {
        const c = this._mock(); const line = c.items.find((i) => i.id == id);
        if (line) line.quantity += qty;
        else c.items.push(Object.assign({ id: id, quantity: qty }, item));
        return this._save(c);
      }
      await fetch("/cart/add.js", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: id, quantity: qty })
      });
      return this.get();
    },
    async change(id, qty) {
      if (PREVIEW) {
        const c = this._mock();
        c.items = c.items.map((i) => (i.id == id ? Object.assign({}, i, { quantity: qty }) : i)).filter((i) => i.quantity > 0);
        return this._save(c);
      }
      await fetch("/cart/change.js", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: String(id), quantity: qty })
      });
      return this.get();
    },
    _mock() {
      let c; try { c = JSON.parse(localStorage.getItem("ss-cart")) || { items: [] }; } catch (e) { c = { items: [] }; }
      c.item_count = c.items.reduce((n, i) => n + i.quantity, 0);
      c.total_price = c.items.reduce((n, i) => n + i.quantity * (i.price || 0), 0);
      return c;
    },
    _save(c) { localStorage.setItem("ss-cart", JSON.stringify({ items: c.items })); return this._mock(); }
  };

  const drawer = $("[data-cart-drawer]");
  const FREE_SHIP = parseInt((drawer && drawer.dataset.freeShip) || "300000", 10); /* paisa */

  function renderCart(cart) {
    $$("[data-cart-count]").forEach((el) => {
      el.textContent = cart.item_count;
      el.classList.remove("bump"); void el.offsetWidth; el.classList.add("bump");
    });
    if (!drawer) return;
    const box = $("[data-cart-items]", drawer);
    const foot = $("[data-cart-foot]", drawer);
    if (!cart.items.length) {
      box.innerHTML = '<div class="cart-empty"><p style="font-size:2.4rem">🛍️</p><p><b>Your bag is empty.</b><br>Your glow ritual is waiting…</p><a class="btn btn--primary" href="' + (drawer.dataset.shopUrl || "/collections/all") + '">Shop the Kit</a></div>';
      foot.classList.add("hide");
      return;
    }
    foot.classList.remove("hide");
    box.innerHTML = cart.items.map((i) => {
      const img = i.image || i.featured_image && i.featured_image.url || "";
      return '<div class="cart-line">' +
        '<img src="' + img + '" alt="" loading="lazy">' +
        '<div class="cart-line__info"><b>' + (i.product_title || i.title) + "</b>" +
        '<span class="cart-line__price">' + money(i.price) + "</span>" +
        '<div class="qty" style="margin-top:.35rem"><button data-qty-minus data-line="' + i.id + '" aria-label="Decrease">−</button>' +
        '<input value="' + i.quantity + '" data-line-qty="' + i.id + '" inputmode="numeric" aria-label="Quantity">' +
        '<button data-qty-plus data-line="' + i.id + '" aria-label="Increase">+</button></div></div>' +
        '<span class="cart-line__rm" data-rm="' + i.id + '">Remove</span></div>';
    }).join("");
    $("[data-cart-total]", drawer).textContent = money(cart.total_price);
    /* free-shipping meter */
    const meter = $("[data-ship-meter]", drawer);
    if (meter) {
      const left = Math.max(0, FREE_SHIP - cart.total_price);
      $(".ship-meter__fill", meter).style.width = Math.min(100, (cart.total_price / FREE_SHIP) * 100) + "%";
      $("small", meter).textContent = left > 0
        ? "You're " + money(left) + " away from FREE delivery 🚚"
        : "🎉 You've unlocked FREE delivery across Pakistan!";
    }
  }

  function openDrawer() { if (!drawer) return; drawer.classList.add("open"); document.body.style.overflow = "hidden"; }
  function closeDrawer() { if (!drawer) return; drawer.classList.remove("open"); document.body.style.overflow = ""; }

  /* Debounced, serialized line updates — rapid +/− clicks batch into one request
     per line and responses can never arrive out of order. */
  const pendingQty = {};
  let qtyTimer, cartBusy = false;
  function queueQtyChange(id, qty) {
    pendingQty[id] = qty;
    clearTimeout(qtyTimer);
    qtyTimer = setTimeout(flushQtyChanges, 400);
  }
  async function flushQtyChanges() {
    if (cartBusy) { qtyTimer = setTimeout(flushQtyChanges, 200); return; }
    const changes = Object.entries(pendingQty);
    if (!changes.length) return;
    changes.forEach(([k]) => delete pendingQty[k]);
    cartBusy = true;
    if (drawer) drawer.classList.add("updating");
    try {
      let cart;
      for (const [id, qty] of changes) cart = await Cart.change(id, qty);
      if (cart) renderCart(cart);
    } catch (err) {
      toast("Couldn't update your bag. Please try again.");
      Cart.get().then(renderCart);
    }
    if (drawer) drawer.classList.remove("updating");
    cartBusy = false;
    if (Object.keys(pendingQty).length) flushQtyChanges();
  }

  if (drawer) {
    $$("[data-cart-open]").forEach((b) => b.addEventListener("click", (e) => { e.preventDefault(); openDrawer(); }));
    $$("[data-cart-close], .cart-drawer__scrim", drawer).forEach((b) => b.addEventListener("click", closeDrawer));
    drawer.addEventListener("click", (e) => {
      const rm = e.target.closest("[data-rm]");
      if (rm) { rm.closest(".cart-line").style.opacity = ".4"; queueQtyChange(rm.dataset.rm, 0); return; }
      const btn = e.target.closest("[data-qty-plus][data-line], [data-qty-minus][data-line]");
      if (!btn) return;
      const id = btn.dataset.line;
      const input = $('[data-line-qty="' + id + '"]', drawer);
      if (!input) return;
      let q = parseInt(input.value, 10);
      if (isNaN(q)) q = 1;
      q = Math.max(0, q + (btn.hasAttribute("data-qty-plus") ? 1 : -1));
      input.value = q;
      queueQtyChange(id, q);
    });
    /* typed quantities */
    drawer.addEventListener("change", (e) => {
      const input = e.target.closest("[data-line-qty]");
      if (!input) return;
      let q = parseInt(input.value, 10);
      if (isNaN(q) || q < 0) q = 1;
      input.value = q;
      queueQtyChange(input.getAttribute("data-line-qty"), q);
    });
    Cart.get().then(renderCart);
  }

  /* Add-to-cart forms/buttons */
  $$("[data-atc]").forEach((btn) => {
    btn.addEventListener("click", async (e) => {
      e.preventDefault();
      const d = btn.dataset;
      const qtyInput = $("[data-main-qty]");
      const qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10)) : 1;
      const label = btn.innerHTML;
      btn.innerHTML = "Adding…"; btn.disabled = true;
      try {
        const cart = await Cart.add(d.atc, qty, {
          title: d.atcTitle, product_title: d.atcTitle,
          price: parseInt(d.atcPrice, 10), image: d.atcImage
        });
        renderCart(cart);
        toast("✨ Added to your bag — glow incoming!");
        openDrawer();
      } catch (err) { toast("Couldn't add to cart. Please try again."); }
      btn.innerHTML = label; btn.disabled = false;
    });
  });

  /* ---------- Sticky ATC bar ---------- */
  const stickyBar = $("[data-sticky-atc]");
  const buybox = $("[data-buybox-anchor]");
  if (stickyBar && buybox) {
    const sio = new IntersectionObserver(([e]) => {
      const show = !e.isIntersecting && e.boundingClientRect.top < 0;
      stickyBar.classList.toggle("show", show);
      document.body.classList.toggle("has-sticky-atc", show);
    }, { threshold: 0 });
    sio.observe(buybox);
  }

  /* ---------- Back to top ---------- */
  const backTop = $("[data-back-top]");
  if (backTop) {
    window.addEventListener("scroll", () => backTop.classList.toggle("show", window.scrollY > 900), { passive: true });
    backTop.addEventListener("click", () => window.scrollTo({ top: 0, behavior: "smooth" }));
  }

  /* ---------- Exit-intent popup (desktop, once/session) ---------- */
  const exitPop = $("[data-exit-pop]");
  if (exitPop && !sessionStorage.getItem("ss-exit") && matchMedia("(pointer:fine)").matches) {
    const show = () => {
      if (sessionStorage.getItem("ss-exit")) return;
      sessionStorage.setItem("ss-exit", "1");
      exitPop.classList.add("open");
    };
    document.addEventListener("mouseout", (e) => {
      if (!e.relatedTarget && e.clientY <= 0) show();
    });
    $$("[data-exit-close], .exit-pop__scrim", exitPop).forEach((b) =>
      b.addEventListener("click", () => exitPop.classList.remove("open")));
  }

  /* ---------- Newsletter (preview mock) ---------- */
  if (PREVIEW) {
    $$("form[data-newsletter]").forEach((f) => {
      f.addEventListener("submit", (e) => {
        e.preventDefault();
        f.innerHTML = '<p style="font-weight:700">💜 Shukriya! You\'re on the Glow List — watch your inbox.</p>';
      });
    });
  }

  /* ---------- UGC reels: autoplay muted in view + auto-advancing slideshow ---------- */
  $$(".reel-rail").forEach((rail) => {
    /* videos autoplay silently while on screen; tap toggles pause */
    const vids = $$("[data-reel] video", rail);
    if (vids.length) {
      const vio = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          const v = en.target, reel = v.closest("[data-reel]");
          if (en.isIntersecting) {
            v.muted = true; v.loop = true; v.playsInline = true;
            v.setAttribute("playsinline", ""); v.setAttribute("muted", "");
            v.play().then(() => reel.classList.add("playing")).catch(() => {});
          } else { v.pause(); reel.classList.remove("playing"); }
        });
      }, { threshold: 0.35 });
      vids.forEach((v) => vio.observe(v));
      $$("[data-reel]", rail).forEach((reel) => {
        const v = $("video", reel);
        if (!v) return;
        reel.addEventListener("click", () => {
          if (v.paused) { v.muted = true; v.play().catch(() => {}); reel.classList.add("playing"); }
          else { v.pause(); reel.classList.remove("playing"); }
        });
      });
    }
    /* gentle slideshow: advance one card every 3.5s while on screen,
       pause while the user hovers or interacts.
       NOTE: smooth scrollTo()/scroll-behavior get cancelled on scroll-snap
       containers in Chrome, so we animate scrollLeft with rAF and suspend
       the snap for the duration of each glide. */
    const cards = Array.from(rail.children);
    const step = () => rail.firstElementChild
      ? rail.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap || "18")
      : 300;

    /* slideshow dots (opt-in via [data-rail-dots] near the rail) */
    const section = rail.closest("[data-rail]") || rail.parentElement;
    const dotWrap = section && section.querySelector("[data-rail-dots]");
    let dots = [];
    if (dotWrap && cards.length > 1) {
      dotWrap.innerHTML = "";
      dots = cards.map((_, i) => {
        const b = document.createElement("button");
        b.type = "button"; b.setAttribute("aria-label", "Go to reel " + (i + 1));
        b.addEventListener("click", () => { holdFor(9000); glide(i * step()); });
        dotWrap.appendChild(b); return b;
      });
      const syncDots = () => {
        const idx = Math.round(rail.scrollLeft / step());
        dots.forEach((d, i) => d.classList.toggle("active", i === Math.min(idx, dots.length - 1)));
      };
      rail.addEventListener("scroll", syncDots, { passive: true });
      syncDots();
    }

    /* gentle slideshow: advance one card every 3.5s while on screen,
       pause while the user hovers or interacts.
       NOTE: smooth scrollTo()/scroll-behavior get cancelled on scroll-snap
       containers in Chrome, so we animate scrollLeft with rAF and suspend
       the snap for the duration of each glide. */
    let hold = 0, visible = false, gliding = false;
    function holdFor(ms) { hold = Date.now() + ms; gliding = false; rail.style.scrollSnapType = ""; }
    function glide(target) {
      const start = rail.scrollLeft, delta = target - start, t0 = performance.now();
      gliding = true;
      rail.style.scrollSnapType = "none";
      const finish = (jump) => {
        if (!gliding) return;
        if (jump) rail.scrollLeft = target;
        rail.style.scrollSnapType = ""; gliding = false;
      };
      const guard = setTimeout(() => finish(true), 900); /* rAF is throttled in hidden tabs */
      (function stepAnim(t) {
        if (!gliding) { clearTimeout(guard); return; }
        const p = Math.min(1, (t - t0) / 650), e = 1 - Math.pow(1 - p, 3);
        rail.scrollLeft = start + delta * e;
        if (p < 1) requestAnimationFrame(stepAnim);
        else { clearTimeout(guard); finish(false); }
      })(t0);
    }

    const autoplay = rail.matches("[data-rail-auto]") || (section && section.matches("[data-rail-auto]"));
    if (!reduceMotion && autoplay && cards.length > 1) {
      ["pointerdown", "wheel", "touchstart"].forEach((ev) =>
        rail.addEventListener(ev, () => holdFor(8000), { passive: true }));
      rail.addEventListener("mouseenter", () => holdFor(600000));
      rail.addEventListener("mouseleave", () => holdFor(1500));
      new IntersectionObserver(([e]) => { visible = e.isIntersecting; }, { threshold: 0.2 }).observe(rail);
      setInterval(() => {
        if (!visible || gliding || Date.now() < hold) return;
        const atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 10;
        glide(atEnd ? 0 : rail.scrollLeft + step());
      }, 3500);
    }
  });

  /* ---------- Hero word-reveal delays ---------- */
  $$(".hero-title .word").forEach((w, i) => { w.style.animationDelay = (0.15 + i * 0.09) + "s"; });
})();
